<template>
  <AppointmentScreenWrapper
    v-if="isDontWorkLpuWithExpress"
    data-qa="appointment_dont_work"
  >
    <template #main>
      <div>
        <v-img
          src="/static/_v1/pd/pictures/ui-kit/clock.svg"
          alt="/"
          class="mx-auto"
          width="162"
          height="133"
        />
        <div class="text-h6 text-text text-center mt-4">
          {{ t('Клиника сейчас не работает', options) }}, <br>
          {{ t('записаться можно', options) }} <br>
          {{ lpuData.nearestAppointmentExpress }}
        </div>
      </div>
    </template>
    <template #actions="{ buttonProps }">
      <v-btn
        v-bind="buttonProps"
        href="/"
        data-qa="appointment_success_first_button"
      >
        {{ t('Перейти на главную', options) }}
      </v-btn>
    </template>
  </AppointmentScreenWrapper>
</template>

<script setup lang="ts">
import I18NextVue from 'i18next'
import { storeToRefs } from 'pinia'
import useLpuDataStore from 'www/vue_components/common/AppointmentPage/stores/useLpuDataStore'
import useAppointmentDataStore from 'www/vue_components/common/AppointmentPage/stores/useAppointmentDataStore'
import AppointmentScreenWrapper from 'www/vue_components/common/AppointmentPage/components/common/AppointmentScreenWrapper.vue'

const { t, language } = I18NextVue
const options = { ns: language }
const { lpuData } = storeToRefs(useLpuDataStore())
const { isDontWorkLpuWithExpress } = storeToRefs(useAppointmentDataStore())
</script>
